/**
 * SPのヘッダーCTA（画面下に固定されるバー）をスクロール開始で出す
 *
 * @description ページ最上部では画面外に逃がしておき、少しスクロールしたらせり上がる。
 *              見た目（translate・transition）はCSS側が持っていて、
 *              ここは .is-shown を付け外しするだけ。
 *              translateはSPのメディアクエリ内にしか無いので、PCで付いても影響しない。
 */

/** これ以上スクロールしたら表示する（px） */
const SHOW_FROM = 40

/**
 * スクロール量を見て表示クラスを付け外しする
 * @param {HTMLElement} cta - .header__cta 要素
 * @returns {void}
 * @description スクロールはrAFで間引き、状態が変わったときだけDOMを触る。
 * @example
 * watchScroll(document.querySelector(".header__cta"))
 */
const watchScroll = (cta: HTMLElement): void => {
  let shown = false
  let ticking = false

  /**
   * 現在のスクロール量でクラスを更新する
   * @returns {void}
   */
  const update = (): void => {
    ticking = false

    const next = window.scrollY > SHOW_FROM

    if (next === shown) {
      return
    }

    shown = next
    cta.classList.toggle("is-shown", shown)
  }

  /**
   * スクロールイベントをrAFへ受け流す
   * @returns {void}
   */
  const onScroll = (): void => {
    if (ticking) {
      return
    }

    ticking = true
    requestAnimationFrame(update)
  }

  window.addEventListener("scroll", onScroll, { passive: true })
  // リロード位置が途中のこともあるので初期状態も見る
  update()
}

const cta = document.querySelector<HTMLElement>(".header__cta")

if (cta) {
  watchScroll(cta)
}
